import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class WorkersStateRequest extends GenericRequest {

    constructor(page, term = '') {
        super(METHOD_GET, ApiEndpoints.WORKERS_STATE);
    }

}



// WEBPACK FOOTER //
// ./src/app/worker/ws/WorkersStatesRequest.js